import { styled } from '@mui/material';

export const Span = styled('span')({});
